var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _circle4, _path5, _path6, _path7, _path8, _path9, _circle5, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFeeds(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 856.36301,
    height: 548.70399,
    viewBox: "0 0 856.36301 548.70399",
    "data-src": "https://cdn.undraw.co/illustrations/my-feed_fo8n.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "aea5e876-5b18-4677-ac52-565f186c2754",
    "data-name": "Rectangle 1",
    x: 0.366,
    y: 0.485,
    width: 855.99701,
    height: 548.21899,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "aeed2be9-3178-4cee-b478-9db2d7f97a20",
    "data-name": "Rectangle 2",
    x: 24.843,
    y: 69.246,
    width: 807.04303,
    height: 447.026,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "b3ae8885-9a9e-4403-9d49-07bff8102aa7",
    "data-name": "Rectangle 9",
    width: 855.99701,
    height: 36.366,
    fill: "#273679"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "b27f3643-394f-4790-b443-091b1b383c54",
    "data-name": "Rectangle 10",
    x: 468.79401,
    y: 118.16399,
    width: 293.76199,
    height: 283.54999,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "e395ce2b-339a-464a-b2a8-2798fb0dfcd4",
    "data-name": "Ellipse 12",
    cx: 27.024,
    cy: 18.592,
    r: 6.74,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "ba9fbbde-097d-4714-9aa4-a15d83836bc3",
    "data-name": "Ellipse 13",
    cx: 52.608,
    cy: 18.592,
    r: 6.74,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "ab9aef1c-a9cb-4a01-bb5b-9a91a857f5fb",
    "data-name": "Ellipse 14",
    cx: 78.192,
    cy: 18.592,
    r: 6.74,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "e493c728-f703-42a2-881c-386585883b73",
    "data-name": "Rectangle 13",
    x: 86.90399,
    y: 117.58101,
    width: 78.336,
    height: 78.336,
    fill: "#273679"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "fef75a5d-72e7-4f52-be39-ca98924ebad3",
    "data-name": "Rectangle 14",
    x: 195.841,
    y: 118.03001,
    width: 78.336,
    height: 78.336,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "b42a9be3-8096-4c9f-95c4-e18278a3579e",
    "data-name": "Rectangle 15",
    x: 196.15201,
    y: 225.63499,
    width: 78.336,
    height: 260.65799,
    fill: "#273679"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "e3bd9f8a-f01d-48ae-a6f1-3d5ac6753111",
    "data-name": "Rectangle 16",
    x: 84.767,
    y: 225.054,
    width: 78.336,
    height: 133.362,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b03a159e-94f4-480c-9a5d-9f23eb0385fc-139",
    "data-name": "Path 4",
    d: "M785.50752,338.6c-12.9-21.792-38.412-22.807-38.412-22.807s-24.863-3.179-40.813,30.009c-14.866,30.935-35.384,60.8-3.3,68.044l5.795-18.036,3.589,19.378a125.5385,125.5385,0,0,0,13.726.235c34.356-1.109,67.074.325,66.021-12C790.70949,387.031,797.91652,359.567,785.50752,338.6Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "edc5401e-f5b9-4166-9a45-6d9296a0e0c2-140",
    "data-name": "Path 5",
    d: "M697.46451,545.527l-43.494,30.2s-25.372,26.58-7.249,26.58,25.372-22.955,25.372-22.955l55.576-24.163Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a1145783-9ad9-4920-9c36-7da703d314d6-141",
    "data-name": "Path 6",
    d: "M714.9825,427.731s-38.057,117.8-25.976,123.838,38.661,9.665,38.661,9.665Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a69c490e-693f-4e62-8a32-5b49f335d225-142",
    "data-name": "Path 7",
    d: "M714.9825,427.731s-38.057,117.8-25.976,123.838,38.661,9.665,38.661,9.665Z",
    transform: "translate(-171.8185 -175.648)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "e424da1a-71ea-46da-8962-7b7b116f82e2-143",
    "data-name": "Path 8",
    d: "M834.62849,576.339h-85.672l60.868-30.808a38.7974,38.7974,0,0,1,3.854,2.851A77.279,77.279,0,0,1,834.62849,576.339Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "e1ba790b-7394-4885-ab4c-2c84c77f3e7f",
    "data-name": "Ellipse 1",
    cx: 567.32802,
    cy: 190.46499,
    r: 31.412,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "f3be7be2-223c-4c9b-8b5e-90f6ae9f04e0-144",
    "data-name": "Path 9",
    d: "M738.54251,392.089s7.249,22.955,0,31.413,39.87-12.082,39.87-12.082-16.914-24.163-12.082-35.037Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "b8fe7dc2-df95-4ac5-a3bc-1c8e36bb8e76-145",
    "data-name": "Path 10",
    d: "M808.13052,496.971l-2.537,16.54s1.281,3.757,2.839,9.231c2.03,7.14,4.531,17.2,5.243,25.637.737,8.554-.375,15.44-5.666,15.875-7.587.628-11.538,5.231-15.477,12.082h-87.4c.23-3.769.507-7.684.834-11.707q.272-3.625.6-7.346c.242-2.851,8.8-56.409,2.368-67.935-13.286-23.8,3.625-37.453,3.625-37.453s2.416-18.123,2.416-24.163c0-4.736,18.557-10.209,26.58-12.36.52-.133.979-.266,1.4-.362,1.389-.362,2.223-.568,2.223-.568l6.343-2.6s17.82-3.443,19.029-5.86a6.139,6.139,0,0,1,3.093-2.2c2.549-1.087,5.8-1.861,6.573-2.634a30.801,30.801,0,0,0,2.984-4.06,16.14792,16.14792,0,0,1,8.892-5.2c12.976-3.274,31.618,3.214,31.618,3.214l-6.524,42.588Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "b7b1d332-0442-4c4a-aa9d-2d666bd52d71-146",
    "data-name": "Path 11",
    d: "M846.07048,470.621l-43.494,30.2s-25.372,26.58-7.249,26.58,25.36609-22.951,25.36609-22.951l55.576-24.163Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "faae9d8a-2ade-475e-8bc6-8f0e7b87a797-147",
    "data-name": "Path 12",
    d: "M771.34851,336.499l-25.208-13.2-15.81,2.45a28.274,28.274,0,0,0-23.24,21.7l-2.96,13.058,17.929-.69,5.009-11.687v11.494l8.273-.318,4.8-18.606,3,19.806,29.409-.6Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "ba178fc8-375d-4438-9c01-c19893b0df8a-148",
    "data-name": "Path 13",
    d: "M815.26147,397.526l8.457-2.416s85.78,35.037,83.364,65.241,1.208,30.2-13.29,31.412-56.78-13.29-55.58-15.706,9.665-14.5,9.665-14.5l-32.621-25.372Z",
    transform: "translate(-171.8185 -175.648)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "b052f10f-e5c3-45aa-968a-35c6c5894796",
    "data-name": "Ellipse 2",
    cx: 598.74102,
    cy: 190.46601,
    r: 4.833,
    fill: "#ffb8b8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "aa772a43-ca79-434e-998e-525da0608a2b",
    "data-name": "Rectangle 17",
    x: 468.79401,
    y: 447.28801,
    width: 293.76199,
    height: 39.168,
    fill: "#e6e6e6"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "b869959f-3b5e-4542-9dd3-67ec9d40b083",
    "data-name": "Rectangle 18",
    x: 84.767,
    y: 387.84703,
    width: 78.336,
    height: 97.865,
    fill: "#e6e6e6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "ed8504c8-ba55-4496-b946-b31fe66f24a3",
    "data-name": "Rectangle 19",
    x: 307.53699,
    y: 118.56499,
    width: 78.336,
    height: 239.85001,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "af23db80-e058-4986-866a-292ebf8abb10",
    "data-name": "Rectangle 20",
    x: 307.22601,
    y: 388.08598,
    width: 78.336,
    height: 97.921,
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFeeds);
export default __webpack_public_path__ + "static/media/no-feeds.db2e49a0ebc7a6fd6ecd6cbf5cc8f99d.svg";
export { ForwardRef as ReactComponent };